
export default [
    {
      path: `/introduction`,
      name: '美术馆简介',
      meta: {
        title: '美术馆简介',
      },
      component: () => import('../views/introduction/index.vue'),
    }
  ]